import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/media/blank.png'


const _withScopeId = n => (_pushScopeId("data-v-29401b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, " Verificación de Ingresos Anteriores en el Sistema Estado Digital - Régimen Penitenciario ")
], -1))
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "pt-9 pb-0" }
const _hoisted_5 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_6 = { class: "me-7 mb-4" }
const _hoisted_7 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "alinear",
  src: _imports_0,
  alt: "image"
}
const _hoisted_10 = { class: "flex-grow-1" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-middle flex-wrap mb-2" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "d-flex align-items-center mb-2" }
const _hoisted_14 = { class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1" }
const _hoisted_15 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_16 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_17 = { class: "d-flex flex-wrap" }
const _hoisted_18 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_22 = {
  key: 1,
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_23 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_24 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa fa-id-card" }, null, -1))
const _hoisted_26 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, null, -1))
const _hoisted_29 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe-americas" }),
      /*#__PURE__*/_createTextVNode(" PAIS ")
    ])
  ])
], -1))
const _hoisted_31 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-birthday-cake" }),
      /*#__PURE__*/_createTextVNode(" FECHA DE NACIMIENTO ")
    ])
  ])
], -1))
const _hoisted_35 = { class: "row col-12 p-5" }
const _hoisted_36 = {
  key: 0,
  class: "py-10"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" A continuación se muestra ")
const _hoisted_38 = { style: {"color":"green"} }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" posible coincidencia ")
const _hoisted_40 = {
  key: 1,
  class: "py-10"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" A continuación se muestran ")
const _hoisted_42 = { style: {"color":"red"} }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" posibles coincidencias ")
const _hoisted_44 = {
  key: 2,
  class: "alert alert-primary d-flex align-items-center py-10 my-10",
  role: "alert"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
  viewBox: "0 0 16 16",
  role: "img",
  "aria-label": "Warning:"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"150%"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, " No existen posibles coincidencias en los registros del Sistema Estado Digital - Régimen Penitenciario")
], -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "round3" }, [
  /*#__PURE__*/_createTextVNode(" Si no se encontró una coincidencia por favor presione"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, " \"Continuar\" ")
], -1))
const _hoisted_49 = { class: "card card-wrap h-100 my-4" }
const _hoisted_50 = { class: "pt-9 pb-0" }
const _hoisted_51 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_52 = { class: "px-5 me-7 mb-4" }
const _hoisted_53 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_54 = ["src"]
const _hoisted_55 = {
  key: 1,
  src: _imports_0,
  alt: "image"
}
const _hoisted_56 = { class: "flex-grow-1" }
const _hoisted_57 = { class: "d-flex justify-content-between align-items-middle flex-wrap mb-2" }
const _hoisted_58 = { class: "d-flex flex-column" }
const _hoisted_59 = { class: "d-flex align-items-center mb-2" }
const _hoisted_60 = { class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1" }
const _hoisted_61 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_62 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_63 = { class: "d-flex flex-wrap" }
const _hoisted_64 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1))
const _hoisted_67 = {
  key: 0,
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_68 = {
  key: 1,
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_69 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_70 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa fa-id-card" }, null, -1))
const _hoisted_72 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_73 = { class: "d-flex align-items-center" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, null, -1))
const _hoisted_75 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe-americas" }),
      /*#__PURE__*/_createTextVNode(" PAIS ")
    ])
  ])
], -1))
const _hoisted_77 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_78 = { class: "d-flex align-items-center" }
const _hoisted_79 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-birthday-cake" }),
      /*#__PURE__*/_createTextVNode(" FECHA DE NACIMIENTO ")
    ])
  ])
], -1))
const _hoisted_81 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_82 = { class: "d-flex align-items-center" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1))
const _hoisted_84 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa fa-file" }),
    /*#__PURE__*/_createTextVNode(" CÓDIGO FILE PRIVADO DE LIBERTAD ")
  ])
], -1))
const _hoisted_86 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_87 = { class: "d-flex align-items-center" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1))
const _hoisted_89 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa fa-file" }),
    /*#__PURE__*/_createTextVNode(" RECINTO PENITENCIARIO ")
  ])
], -1))
const _hoisted_91 = {
  key: 0,
  class: "round3"
}
const _hoisted_92 = {
  key: 1,
  class: "round3"
}
const _hoisted_93 = {
  key: 2,
  class: "round3"
}
const _hoisted_94 = {
  key: 3,
  class: "round3"
}
const _hoisted_95 = ["onClick"]
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" Registrar ")
const _hoisted_97 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.fotografia)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "alinear",
                    src: _ctx.fotografia,
                    alt: "image"
                  }, null, 8, _hoisted_8))
                : (_openBlock(), _createElementBlock("img", _hoisted_9))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.nombres.toUpperCase()) + " " + _toDisplayString(_ctx.primerApellido.toUpperCase()) + " " + _toDisplayString(_ctx.segundoApellido.toUpperCase()), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      (_ctx.numero_documento)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.numero_documento), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, " Sin número de documento de identidad "))
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, [
                        _hoisted_25,
                        _createTextVNode(" " + _toDisplayString(_ctx.tipoDocumento), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.lugarNacimientoPais), 1)
                    ]),
                    _hoisted_30
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDate(_ctx.fechaNacimiento)), 1)
                    ]),
                    _hoisted_34
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      (_ctx.formData.length === 1)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("strong", _hoisted_38, _toDisplayString(_ctx.formData.length), 1),
            _hoisted_39
          ]))
        : (_ctx.formData.length > 1)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("strong", _hoisted_42, _toDisplayString(_ctx.formData.length), 1),
              _hoisted_43
            ]))
          : (_ctx.formData.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_47))
            : _createCommentVNode("", true),
      _hoisted_48,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: _normalizeClass(_ctx.formData.length === 1 ? 'col-md-12 my-4' : 'col-md-6 my-4')
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    (item.imagen_segip !== 'null')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.imagen_segip,
                          alt: "image"
                        }, null, 8, _hoisted_54))
                      : (_openBlock(), _createElementBlock("img", _hoisted_55))
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("a", _hoisted_60, _toDisplayString(item.nombres) + " " + _toDisplayString(item.primer_apellido) + " " + _toDisplayString(item.segundo_apellido), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass([
                          item.nombre_estado_persona === 'ACTIVO' ||
                          item.nombre_estado_persona === 'TRASLADO'
                            ? 'badge rounded-pill bg-primary'
                            : item.nombre_estado_persona === 'LIBRE'
                            ? 'badge rounded-pill bg-success'
                            : item.nombre_estado_persona === 'FALLECIDO'
                            ? 'badge rounded-pill bg-warning'
                            : item.nombre_estado_persona === 'EVACIÓN'
                            ? 'badge rounded-pill bg-danger'
                            : item.nombre_estado_persona ===
                              'DETENCION DOMICILIARIA'
                            ? 'badge rounded-pill bg-info'
                            : 'badge rounded-pill bg-info',
                        ])
                        }, _toDisplayString(item.nombre_estado_persona === "ACTIVO" ||
                          item.nombre_estado_persona === "TRASLADO"
                            ? "RECLUIDO"
                            : item.nombre_estado_persona === "LIBRE"
                            ? "PERSONA EN LIBERTAD"
                            : item.nombre_estado_persona === "FALLECIDO"
                            ? "PERSONA FALLECIDA"
                            : item.nombre_estado_persona === "EVACIÓN"
                            ? "REGISTRO DE EVASIÓN"
                            : item.nombre_estado_persona ===
                              "DETENCION DOMICILIARIA"
                            ? "REGISTRO DE DETENCIÓN DOMICILIARIA"
                            : ""), 3)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _hoisted_66,
                            (item.nro_documento)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(item.nro_documento), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_68, " Sin número de documento de identidad "))
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("span", _hoisted_70, [
                              _hoisted_71,
                              _createTextVNode(" " + _toDisplayString(item.nombre_tipo_documento_identidad), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _hoisted_74,
                            _createElementVNode("div", _hoisted_75, _toDisplayString(item.pais), 1)
                          ]),
                          _hoisted_76
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.formatDate(item.fecha_nacimiento)), 1)
                          ]),
                          _hoisted_80
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _hoisted_83,
                            _createElementVNode("div", _hoisted_84, _toDisplayString(item.codigo_file_ppl), 1)
                          ]),
                          _hoisted_85
                        ]),
                        (
                          item.nombre_estado_persona === 'ACTIVO' ||
                          item.nombre_estado_persona === 'TRASLADO'
                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              _createElementVNode("div", _hoisted_87, [
                                _hoisted_88,
                                _createElementVNode("div", _hoisted_89, _toDisplayString(item.nombre_recinto_penitenciario) + "-" + _toDisplayString(item.departamento), 1)
                              ]),
                              _hoisted_90
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (
                        item.nombre_estado_persona === 'ACTIVO' ||
                        item.nombre_estado_persona === 'TRASLADO'
                      )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_91, " Esta persona se encuentra actualmente RECLUIDA en el centro penitenciario " + _toDisplayString(item.nombre_recinto_penitenciario) + "-" + _toDisplayString(item.departamento) + ", por favor contactese con el administrador para obtener más información. ", 1))
                        : _createCommentVNode("", true),
                      (item.nombre_estado_persona === 'FALLECIDO')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_92, " Esta persona se encuentra con registro FALLECIDO en el Sistema Estado Digital - Régimen Penitenciario , por favor contactese con el administrador para obtener más información. "))
                        : _createCommentVNode("", true),
                      (item.nombre_estado_persona === 'EVACIÓN')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_93, " Esta persona se encuentra con registro de EVASIÓN en el Sistema Estado Digital - Régimen Penitenciario , por favor realice la búsqueda en la LISTA DE PRIVADOS DE LIBERTAD CON EVASIÓN si desea realizar la adición de la orden judicial. "))
                        : _createCommentVNode("", true),
                      (
                        item.nombre_estado_persona === 'DETENCION DOMICILIARIA'
                      )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_94, " Esta persona se encuentra con registro de DETENCIÓN DOMICILIARIA en el Sistema Estado Digital - Régimen Penitenciario , por favor contactese con el administrador para obtener más información. "))
                        : _createCommentVNode("", true)
                    ]),
                    (item.nombre_estado_persona === 'LIBRE')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          onClick: ($event: any) => (_ctx.newReentry(item.id_persona)),
                          class: "btn btn-lg btn-primary"
                        }, [
                          _hoisted_96,
                          _createElementVNode("span", _hoisted_97, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ], 8, _hoisted_95))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ], 2))
      }), 128))
    ])
  ]))
}